import {formatSyncStatusLabel} from './syncStatusDisplayUtils'

export type ShipmentSyncRow = {
  id?: number
  sync_status?: string | null
  sync_message?: string | null
}

const isFailedShipment = (shipment: ShipmentSyncRow) =>
  shipment.sync_status === 'ERROR' || shipment.sync_status === 'FAILED'

const formatShipmentOrdinal = (index: number) => {
  const number = index + 1
  const suffix =
    number % 10 === 1 && number % 100 !== 11
      ? 'st'
      : number % 10 === 2 && number % 100 !== 12
        ? 'nd'
        : number % 10 === 3 && number % 100 !== 13
          ? 'rd'
          : 'th'

  return `${number}${suffix}`
}

const formatShipmentSyncStatusLabel = (syncStatus?: string | null) => {
  if (!syncStatus?.trim()) return 'Unknown'
  return formatSyncStatusLabel(syncStatus)
}

const formatShipmentLine = (shipment: ShipmentSyncRow, index: number) => {
  const ordinal = formatShipmentOrdinal(index)
  const statusLabel = formatShipmentSyncStatusLabel(shipment.sync_status)
  const message = shipment.sync_message?.trim()

  if (message) {
    return `${ordinal} shipment : ${statusLabel}:${message}`
  }

  return `${ordinal} shipment : ${statusLabel}`
}

/** Aggregate per-shipment sync messages and pick the best resync target for the grid. */
export function getShipmentSyncSummary(shipments: ShipmentSyncRow[] = []) {
  const list = Array.isArray(shipments) ? shipments : []

  const failed = list.filter(isFailedShipment)
  const pending = list.filter((shipment) => shipment.sync_status === 'PENDING')

  let aggregatedMessage: string | undefined

  if (list.length > 1) {
    aggregatedMessage = list.map((shipment, index) => formatShipmentLine(shipment, index)).join('\n\n')
  } else if (list.length === 1) {
    aggregatedMessage = list[0].sync_message?.trim() || undefined
  }

  const resyncTarget = failed[0] ?? pending[0] ?? list[0]

  return {
    aggregatedMessage,
    resyncShippingId: resyncTarget?.id,
  }
}
